enum ApiErrorType {
  Generic = 'minbank/error/generic',
  PaymentAgreementsEmailExists = 'minbank/error/paymentagreement/email-alias-already-taken',
  PaymentAgreementsPhoneExists = 'minbank/error/paymentagreement/phone-alias-already-taken',
}

export default ApiErrorType;
